// Функция удаляет хвост. Искомый символ остаётся
export const cutMyStringMin = (str: string, char: string) => {
	if (!str) return ''
	if (str.includes(char))
		return str.replace(new RegExp(`${char}.*`), '') + '...'
	return str.replace(new RegExp(`${char}.*`), '')
}
